<custom-modal [header]="title" [(open)]="isModalOpen">
  <div>
    <p class="f-bold">{{ descriptionText1 | translate : { code: code | translate } }}</p>
    <div class="list-error">
      <ng-container *ngFor="let e of backError">
        <p
          *ngIf="showErrorKey || showErrorTitle"
          [ngClass]="{
            error: enumValidationMessageSeverity.ERROR === e.severity,
            warning: enumValidationMessageSeverity.WARNING === e.severity
          }"
        >
          <ng-template [ngIf]="showErrorKey">
            <span [innerHTML]="e.key | translate : e.keyParams"></span>
          </ng-template>

          <ng-template [ngIf]="showErrorTitle">
            <span [innerHTML]="e.title | translate : e.params"></span>
          </ng-template>
        </p>
      </ng-container>
    </div>
    <p *ngIf="canDecline">{{ descriptionText2 | translate : { code: code | translate } }}</p>
  </div>
  <button footer-action type="button" class="btn btn-primary" *ngIf="canConfirm" (click)="onConfirm()">
    {{ confirmTitle | translate }}
  </button>
  <button footer-action type="button" class="btn btn-secondary" *ngIf="canDecline" (click)="onDecline()">
    {{ declineTitle | translate }}
  </button>
</custom-modal>
